module.exports = __webpack_public_path__ + "images/_/programs/epsHybridAssembly/images/characters/apprenticePointingUp2-9c0ac37f7e4a051b551e8d86a6fbf1fb.png";


//////////////////
// WEBPACK FOOTER
// ./programs/epsHybridAssembly/images/characters/apprenticePointingUp2.png
// module id = 2260
// module chunks = 2